import getAuthToken from './auth-token';

export default {
  getAuthToken,
};
